<template>
  <div class="study-item v3_box_teal">
    <template v-if="!questionnaire">
      Your Society doesn't have the active Questionnaire
    </template>
    <template v-else>
      <div class="v3_box_teal_header shadow-none">
        <b-row align-v="center">
          <b-col
            xs="12"
            md="6"
            lg="5"
            xl="6"
            class="d-flex align-items-center v3_color_teal"
          >
            <h3 class="mb-0 font_size_1000rem">
              <strong>{{ questionnaireTitle }}</strong>
            </h3>
            <span class="ml-md-3 font_size_875rem">
              Study Period: {{ questionnaireStartDate }} -
              {{ questionnaireClosedDate }}
            </span>
          </b-col>
          <b-col
            cols="12"
            md="6"
            lg="7"
            xl="6"
            class="d-flex justify-content-lg-end flex-column flex-lg-row my-2 my-lg-0"
          >
          <template v-if="questionnaire.isPrimary && !studyIsSubmitted">
              <b-button
                variant="v3_teal_outline"
                class="mr-2 mb-2 mb-lg-0"
                :disabled="buttonIsDisabled || beginLoading"
                @click="onStudyClick"
              >
                <b-spinner v-if="beginLoading" small />
                <span v-else>{{ buttonTitle }}</span>
              </b-button>
          </template>
            <b-button
            v-if="this.checkViewDataAccess(questionnaire.id)"
              variant="v3_teal_outline"
              class="mr-2 mb-2 mb-lg-0"
              :to="`/user/filters/${questionnaire.id}`"
            >
              View Data
            </b-button>
            <b-button
              v-if="worksheetUrl"
              variant="v3_teal_outline"
              :href="worksheetUrl"
              class="mr-2 mb-2 mb-lg-0"
              target="_blank"
            >
              <i class="mdi mdi-download my-n3" />
              Study Guide
            </b-button>

            <b-button
              v-if="isDemoMode && showResetButton && study"
              variant="v3_red_outline"
              class="mr-2 mb-2 mb-lg-0"
              @click="resetSurvey"
            >
              <template v-if="!resetLoading">
                <i class="mdi mdi-cached mr-2" />
                Reset Survey
              </template>
              <template v-else>
                <b-spinner small />
              </template>
            </b-button>
            <b-button
              class="v3_button_collapse text-decoration-none"
              v-b-toggle="`questionnaire-info-${questionnaire.id}`"
              variant="link"
            >
              <span class="when-closed when">
                <span>Expand</span>
                <i class="mdi mdi-chevron-down" />
              </span>
              <span class="when-opened when">
                <span>Collapse</span>
                <i class="mdi mdi-chevron-up" />
              </span>
            </b-button>
          </b-col>
        </b-row>
      </div>
      <b-collapse
        :id="`questionnaire-info-${questionnaire.id}`"
        visible
        class="v3_box_teal_body p-1 p-xl-2"
        ref="test"
      >
        <b-row class="box-body-wrapper p-xl-3 p-1 p-md-2 m-3">
          <b-col md="6" v-if="study">
            <card-box :title="'Core Study'">
              <template slot="body">
                <b-row class="">
                  <b-col
                    xs="12"
                    sm="4"
                    md="12"
                    lg="4"
                    class="text-left d-flex justify-content-center flex-column mb-2 mb-xl-0 align-items-md-center"
                  >
                    <status-column
                      :title="'Started On'"
                      :value="studyStarted"
                    />
                  </b-col>
                  <b-col
                    xs="12"
                    sm="4"
                    md="12"
                    lg="4"
                    class="text-left d-flex justify-content-center flex-column mb-2 mb-xl-0 align-items-md-center"
                  >
                    <status-column
                      v-if="studyIsSubmitted"
                      :title="'Completed On'"
                      :value="studySubmitted"
                    />
                    <status-column
                      v-else
                      :title="'Last Accessed'"
                      :value="studyUpdated"
                    />
                  </b-col>
                  <b-col
                    xs="12"
                    sm="4"
                    md="12"
                    lg="4"
                    class="text-left d-flex justify-content-center flex-column mb-2 mb-xl-0 align-items-md-center"
                  >
                    <donut :label="'Completed'" :percent="completionPercent" />
                  </b-col>
                </b-row>
              </template>
            </card-box>
          </b-col>
          <b-col :md="!!study ? 6 : 12">
            <card-box
              :title="
                questionnaire.society ? 'Society Status' : 'Society Participation Data'
              "
            >
              <template slot="body">
                <b-row class="">
                  <b-col
                    xs="12"
                    sm="4"
                    md="12"
                    lg="4"
                    class="text-left d-flex justify-content-center flex-column mb-2 mb-xl-0 align-items-md-center"
                  >
                    <donut
                      :label="'Completion'"
                      :percent="membersCompletionPercentage"
                    />
                  </b-col>
                  <b-col
                    xs="12"
                    sm="4"
                    md="12"
                    lg="4"
                    class="text-left d-flex justify-content-center flex-column mb-2 mb-xl-0 align-items-md-center"
                  >
                    <donut
                      :label="'Sample: Convenience'"
                      :percent="convenienceParticipationPercentage"
                    />
                  </b-col>
                  <b-col
                    xs="12"
                    sm="4"
                    md="12"
                    lg="4"
                    class="text-left d-flex justify-content-center flex-column mb-2 mb-xl-0 align-items-md-center"
                  >
                    <donut
                      :label="'Sample: Random'"
                      :percent="randomParticipationPercentage"
                    />
                  </b-col>
                </b-row>
              </template>
            </card-box>
          </b-col>
        </b-row>
        <template v-if="moduleSections.length > 0">
          <div
            class="box-body-wrapper justify-content-start p-xl-3 p-1 p-md-2 m-3"
          >
            <b-container fluid>
              <b-row>
                <b-col cols="12" class="font_Montserrat font_size_1000rem my-3">
                  Complete these subject-specific modules to access more data.
                </b-col>
              </b-row>
              <b-row>
                <template v-for="section in moduleSections">
                  <b-col
                    :key="section.id"
                    class="mb-3"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                    xl="2"
                  >
                    <module-section-card
                      :study-id="(study || {}).id"
                      :section="section"
                      :disabled="!study || !study.submitted"
                      @click.native="moduleNativeClick"
                    />
                  </b-col>
                </template>
              </b-row>
            </b-container>
          </div>
        </template>
      </b-collapse>
    </template>
  </div>
</template>

<script>
import Api from '@/providers/Api';
import {
  CREATE_SURVEY_ACTION,
  DELETE_RESET_SURVEY_FROM_COMPLETED_MUTATION,
} from '@/store';
import Donut from '@/components/ui-elements/PercentageDonut';
import CardBox from '@/components/dashboard/CardBox';
import StatusColumn from '@/components/dashboard/StatusColumn';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import ModuleSectionCard from '@/components/study/module_sections/ModuleSectionCard';
import { loadFromStorage, saveToStorage } from '@/helpers/localStorageHelper';
import { isApplicableQuestion } from '@/helpers/questionnaireHelper';

export default {
  name: 'StudyItem',
  components: {
    StatusColumn,
    Donut,
    CardBox,
    ModuleSectionCard,
  },
  props: {
    questionnaire: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      default: null,
    },
    study: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      default: null,
    },
    society: {
      type: Object,
      default: function () {
        const user = this.$store.state.user;
        return user && user.society_id ? user.society : {};
      },
    },
    showResetButton: {
      type: Boolean,
      default: false,
    },
    surveyList:{
      default: null
    }
  },
  data: function () {
    return {
      resetLoading: false,
      beginLoading: false,
      completeSurvey: null,
      isUpdateData:false,
    };
  },
  computed: {
    studyStarted: function () {
      return this.study
        ? this.$dayjs(this.study.created).format('MMM D, YYYY')
        : 'Not Started';
    },
    studyUpdated: function () {
      return this.study
        ? this.$dayjs(this.study.updated || this.study.created).format(
            'MMM D, YYYY'
          )
        : 'Not Started';
    },
    studySubmitted: function () {
      return this.study && this.studyIsSubmitted
        ? this.$dayjs(this.study.submitted).format('MMM D, YYYY')
        : 'Not Started';
    },
    completionPercent: function () {
      if (
        !this.study ||
        !this.study.questionsCompleted ||
        !this.study.questionsTotal
      )
        return 0;
      const result = Math.round(
        (this.study.questionsCompleted / this.study.questionsTotal) * 100
      );
      if (isNaN(result)) return 0;
      return result;
    },
    buttonTitle: function () {
      this.setUpdateData();
      // if(this.questionnaire && this.questionnaire.prior_year_questionnaire_id !== null)
      if(this.user && this.user.questionnaire
      && this.user.questionnaire.prior_year_questionnaire_id
      && this.matchPriorQuetionnaire.length > 0
      )
      {
          return  'Update Data';
      }else{
          return this.study ? 'Continue Study' : 'Begin Study'; 
      }
      //return this.study ? 'Continue Study' : 'Begin Study';
    },
    buttonIsDisabled: function () {
      if (!this.questionnaire.isActive || !this.user) return true;
      return this.$store.getters.userIsNonMSSUser
        ? !Array.isArray(this.questionnaire.nonSocietyMembershipTypes) ||
            !this.questionnaire.nonSocietyMembershipTypes.some(
              ({ id }) => id === this.user.society_membership_type_id
            )
        : !Array.isArray(this.questionnaire.societyMembershipTypes) ||
            !this.questionnaire.societyMembershipTypes.some(
              ({ id }) => id === this.user.society_membership_type_id
            );
    },
    studyIsSubmitted: function () {
      return this.study && this.study.submitted;
    },
    societyStatus: function () {
      return this.questionnaire.statistic || null;
    },
    membersCompletionPercentage: function () {
      if (this.isDemoMode) return this.convenienceParticipationPercentage;
      return this.societyStatus &&
        this.societyStatus.membersCompletionPercentage
        ? this.societyStatus.membersCompletionPercentage
        : 0;
    },
    convenienceParticipationPercentage: function () {
      if (this.isDemoMode) {
        const key = `study-convenience-${(this.questionnaire || {}).id}`;
        let value = loadFromStorage(key);
        if (!value || value < 45 || value > 75) {
          value = Math.floor(Math.random() * (75 - 45 + 1)) + 45;
          saveToStorage(key, value);
        }
        return value;
      }
      return this.societyStatus &&
        this.societyStatus.convenienceParticipationPercentage
        ? this.societyStatus.convenienceParticipationPercentage
        : 0;
    },
    randomParticipationPercentage: function () {
      if (this.isDemoMode) return 0;
      return this.societyStatus &&
        this.societyStatus.randomParticipationPercentage
        ? this.societyStatus.randomParticipationPercentage
        : 0;
    },
    user: function () {
      return this.$store.state.user;
    },
    isDemoUser: function () {
      return !!this.user.is_demo;
    },
    matchPriorQuetionnaire: function () {
      return this.user.completed_surveys.filter(
        survey => survey.questionnaire_id === this.user.questionnaire.prior_year_questionnaire_id
      );
    },
    fileStoreUrl: function () {
      return this.$store.state.settings.file_store_url || '';
    },
    worksheetUrl: function () {
      if (!this.questionnaire.worksheet_file_name) return null;
      let url = this.fileStoreUrl;
      url = url.replace(/\/?$/, '/');
      return url + this.questionnaire.worksheet_file_name;
    },
    questionnaireTitle: function () {
      return this.questionnaire
        ? `${this.questionnaire.period} ${this.questionnaire.title}`
        : 'Study Insights';
    },
    questionnaireStartDate: function () {
      return this.questionnaire
        ? this.$dayjs(this.questionnaire.start_date).format('MMM D, YYYY')
        : '';
    },
    questionnaireClosedDate: function () {
      return this.questionnaire
        ? this.$dayjs(this.questionnaire.end_date).format('MMM D, YYYY')
        : '';
    },
    isDemoMode: function () {
      return this.$store.getters.isDemoMode;
    },
    moduleSections: function () {
      return this.questionnaire && Array.isArray(this.questionnaire.sections)
        ? this.questionnaire.sections.filter(({ is_module }) =>
            Boolean(parseInt(is_module))
          )
        : [];
    },
    completeQuestionnaire() {
      return this.completeSurvey && this.completeSurvey.survey && this.completeSurvey.survey.questionnaire;
    },
    sections: function () {
      if (!this.completeQuestionnaire) return [];
      return this.completeQuestionnaire.sections;
    },
    questions: function () {
      const surveyQuestions = this.sections.flatMap((s) =>
        Array.isArray(s.questionSections)
          ? s.questionSections.map((qs) => qs.question)
          : []
      );
      return surveyQuestions;
    },
    moduleQuestions() {
      const surveyQuestions = this.sections.flatMap((s) =>
        Array.isArray(s.questionSections) && s.is_module
          ? s.questionSections.map((qs) => qs.question)
          : []
      );
      return surveyQuestions;
    },
    preVariables: function () {
      return this.questions.flatMap((q) =>
        Array.isArray(q.variables) ? q.variables.map((v) => v) : []
      );
    },
    variables() {
      if (!this.completeSurvey || !this.completeSurvey.survey || !this.completeSurvey.survey.responses) 
        return this.preVariables;
      return this.preVariables.map(x => ({
        ...x,
        response: this.completeSurvey.survey.responses.find(r => r.variable_id === x.id)
      }));
    },
    allQuestionsApplicable() {
      for(let i = 0; i < this.moduleQuestions.length; i++) {
        if(!isApplicableQuestion(this.moduleQuestions[i], this.variables))
          return false;
      }
      return true;
    },
  },
  methods: {
    getSurveyData: async function () {
      this.$wait.start('listSurveyDataLoading');
      try {
        if (!this.questionnaire.survey) return;
        this.completeSurvey = await Api.getSurvey(this.questionnaire.survey.id);
      } catch (error) {
        process.env.NODE_ENV !== 'production' && console.error(error);
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.$wait.end('listSurveyDataLoading');
      }
    },
    onStudyClick: function () {
      if(this.user && this.user.questionnaire
      && this.user.questionnaire.prior_year_questionnaire_id
      && this.matchPriorQuetionnaire.length > 0
      ){
        this.study ? this.continuePriorYearStudy() : this.beginPriorYearStudy();
      }else{
        this.study ? this.continueStudy() : this.beginStudy();
      }
      
    },
    continueStudy: function () {
      // if(this.isUpdateData){
      //   this.$router.push(`/update-prior-year-study/${this.questionnaire.survey.id}`);
      // }else{
        this.$router.push(`/surveyForm/${this.questionnaire.survey.id}`);
      // }
    },
    beginStudy: async function () {
      this.beginLoading = true;
      try {
        const isUserProfileFilled = await Api.isUserProfileFilled();
        if (!isUserProfileFilled) {
          this.$root.$once(
            `user-profile-form-submitted-${this.questionnaire.id}`,
            this.beginStudy
          );
          this.$emit('fill-user-profile', this.questionnaire.id);
          return;
        }
        const survey = await this.$store.dispatch(CREATE_SURVEY_ACTION, {
          questionnaireId: this.questionnaire.id,
        });
        // if(this.isUpdateData){
        //   this.$router.push(`/update-prior-year-study/${survey.id}`);
        // }else{
          this.$router.push(`/surveyForm/${survey.id}`);
        // }
        
      } catch (e) {
        handleServerErrorWithValidation(e, this.$toasted);
      } finally {
        this.beginLoading = false;
      }
    },
    beginPriorYearStudy: async function () {
      this.beginLoading = true;
      try {
        const isUserProfileFilled = await Api.isUserProfileFilled();
        if (!isUserProfileFilled) {
          this.$root.$once(
            `user-profile-form-submitted-${this.questionnaire.id}`,
            this.beginStudy
          );
          this.$emit('fill-user-profile', this.questionnaire.id);
          return;
        }
        const survey = await this.$store.dispatch(CREATE_SURVEY_ACTION, {
          questionnaireId: this.questionnaire.id,
        });
        // if(this.isUpdateData){
          this.$router.push(`/update-prior-year-study/${survey.id}`);
        // }else{
          // this.$router.push(`/surveyForm/${survey.id}`);
        // }
        
      } catch (e) {
        handleServerErrorWithValidation(e, this.$toasted);
      } finally {
        this.beginLoading = false;
      }
    },
    continuePriorYearStudy: function () {
            this.$router.push(`/update-prior-year-study/${this.questionnaire.survey.id}`);
    },
    resetSurvey: async function () {
      if (!this.study) return;
      try {
        this.resetLoading = true;
        await Api.resetSurvey(this.study.id);
        this.$store.commit(
          DELETE_RESET_SURVEY_FROM_COMPLETED_MUTATION,
          this.study.id
        );
        this.$toasted.success('Studies reset successful', { duration: 3000 });
        this.$emit('reseted-study');
      } catch (e) {
        handleServerErrorWithValidation(e, this.$toasted);
      } finally {
        this.resetLoading = false;
      }
    },
    moduleNativeClick() {
      if (!this.study || !this.study.submitted) 
        this.$toasted.info(
          'This module is not enabled until you complete the core portion of the study.',
           { duration: 3000 }
          );
    },
    setUpdateData: function () {
        if(this.questionnaire && this.questionnaire.prior_year_questionnaire_id !== null)
        {
            this.isUpdateData=true;
        }else{
            this.isUpdateData=false;
        }
    },
    checkViewDataAccess :  function (qsid) {
      const item = this.surveyList.find(item => item.questionnaire_id == qsid);
      if (item) {
          if (item.view_data) {
            return true;
          } else {
            return false;
          }
      } else {
        return false;
      }  
    }
  },
};
</script>

<style lang="scss">
@import '../../../sass/v3.scss';

.phairify-buttons-box {
  height: 100%;
  min-height: 95px;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  justify-content: space-around;
}
.box-body-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: none;
  border-radius: 0;
  background-color: rgba($v3_color_black_knight, 0.025);
  padding: 4rem;
}
</style>
